var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"icon-btn",attrs:{"elevation":"1","color":"primary"},on:{"click":function($event){return _vm.$emit('export-csv')}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'file-export']}}),_vm._v(" Export ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }